import { IconButton, Stack, Badge, Popover, Box, List, ListItemButton } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useEffect, useState } from "react";
import apiCNP from "../services/apiCNP";


export default function ProvinciaFilter(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [provincias, setProvincias] = useState([]);
  const open = Boolean(anchorEl);

  const onClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    apiCNP.get('/provincias')
      .then(res => {
        setProvincias(res?.data?.provincias);
      }).catch(err => console.error(err));

  }, []);

  //  FILTRA O ID DA PROVINCIA SELECIONADA PARA SER USADO NO FILTRO DE MUNICIPIOS
  useEffect(() => {
    if (props?.provincia && props?.setProvinciaId) {
      const provinciaSelecionada = provincias.find(p => p.designacao === props.provincia);
      if (provinciaSelecionada) {
        props?.setProvinciaId(provinciaSelecionada._id);
        localStorage.setItem("provinciaId", provinciaSelecionada._id);
      } else {
        props?.setProvinciaId("");
      }
    } else {
      // props?.setProvinciaId("");
    }
  }, [props?.provincia]);

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <IconButton
        size="small"
        htmlFor="provincia-select"
        onClick={(e) => {
          setAnchorEl(e.currentTarget);
        }}
      >
        <Badge
          color="primary"
          variant="dot"
          invisible={!props.provincia}
        >
          <FilterListIcon fontSize="small" />
        </Badge>
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box minWidth={200}>

          <List component="nav" aria-label="secondary mailbox folder">
            <ListItemButton
              selected={props.provincia === ""}
              onClick={(event) => {
                props.setProvincia("");
                onClose();
              }}
            >
              Geral
            </ListItemButton>

            {provincias?.map((provincia) => (
              <ListItemButton
                key={provincia._id}
                selected={props?.provincia === provincia?.designacao}
                onClick={(event) => {
                  props.setProvincia(provincia?.designacao);
                  onClose();
                }}
              >
                {provincia.designacao}
              </ListItemButton>
            ))}
          </List>
        </Box>
      </Popover>
    </Stack>
  );
};


